import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, } from 'rxjs';
import * as rx from 'rxjs';
import { combineLatest, filter, first, map, mergeMap, distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { FiltersTypeEnum, IFilterComboComponent, IFilterTextComponent, WaHelperService, WCupRankingCategoryListLocator, WCupSeasonLocator } from 'world-archery-lib';
import { SeriesItemLocator, ViewDataService } from 'world-archery-lib';
import { FiltersAbstractService } from '../../../common-page-components/classes/filters-abstract-service';
import { CountryCombo } from 'src/app/common-page-components/stores/filters-store/filters-store';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "../../../library/wa-services/wa-helper-service";
import * as i2 from "../../../library/wa-services/view-data-service";
import * as i3 from "@angular/router";
import * as i4 from "@angular/common/http";
/**
 *
 *
 * @export
 * @class FilterWCupRankingService
 * @extends {FiltersAbstractService}
 */
export class FilterWCupRankingService extends FiltersAbstractService {
    constructor(helper, views, router, http) {
        super();
        this.helper = helper;
        this.views = views;
        this.router = router;
        this.http = http;
        this.countryCombo = new CountryCombo('Country:', 'countrycombo', this.http, [{ item: { CShort: 'All' }, position: 0 }]);
        this.filtersType = [
            {
                options: {
                    type: FiltersTypeEnum.TextSearch,
                    id: 'wcuptextfilter',
                    defaultTextValue: '',
                    text_subject: new BehaviorSubject(''),
                    intercept_name: 'search'
                }
            },
            {
                options: {
                    type: FiltersTypeEnum.ComboBox,
                    name_filter: 'Event:',
                    options_subject: new BehaviorSubject([
                        { name: 'Individual' },
                        { name: 'Mixed' }
                    ]),
                    option_name_property: 'name',
                    options_selected_subject: new BehaviorSubject({
                        name: 'Individual'
                    }),
                    id: 'wcupeventcombo',
                    intercept_name: 'event'
                }
            },
            {
                options: {
                    type: FiltersTypeEnum.ComboBox,
                    intercept_name: 'category',
                    name_filter: 'Categories:',
                    options_subject: new BehaviorSubject([]),
                    option_name_property: 'name',
                    options_selected_subject: new BehaviorSubject({}),
                    id: 'wcupcategoriescombo'
                }
            },
            {
                options: {
                    type: FiltersTypeEnum.ComboBox,
                    initial_state: true,
                    intercept_name: 'year',
                    name_filter: 'Year:',
                    options_subject: new BehaviorSubject([]),
                    option_name_property: 'year',
                    options_selected_subject: new BehaviorSubject({}),
                    id: 'wcupyearcombo'
                }
            },
            this.countryCombo.filterInfo
        ];
        this.generateDefaultValues();
        this.sortLocator.asc = true;
    }
    /**
     * Method implemented for get streams of filters
     *
     * @returns {Observable<any>}
     * @memberof FilterWCupRankingService
     */
    getDataStreamWithFilters() {
        return rx.combineLatest(this.orderValue, (this.filtersType[0].options).text_subject
            .asObservable()
            .pipe(distinctUntilChanged(), debounceTime(500)), (this.filtersType[2].options).options_selected_subject
            .asObservable()
            .pipe(filter(category => category !== undefined)), (this.filtersType[3].options).options_selected_subject
            .asObservable()
            .pipe(filter(season => season !== undefined)), this.countryCombo.comboData);
    }
    generateDefaultValues() {
        const WCupRankingCategorySeason = new SeriesItemLocator();
        const WCupActiveSeason = new WCupSeasonLocator();
        WCupRankingCategorySeason.discipline.id = 1;
        const rankingSeasonLocator = this.views.get(WCupRankingCategorySeason);
        const activeSeasonLocator = this.views.get(WCupActiveSeason);
        rankingSeasonLocator.setExpectedItemNumber(1000);
        rankingSeasonLocator
            .getDataStream()
            .pipe(combineLatest(activeSeasonLocator.getDataStream()
            .pipe(map(a => a[0]))), first())
            .subscribe(([next, activeSeason]) => {
            const comboSeason = [];
            // Workdaround for delete year 2020 https://app.asana.com/0/1156796691380146/1199916369826247
            const indexYear2020 = next.findIndex(season => season.year === 2020);
            if (indexYear2020 > -1) {
                next.splice(indexYear2020, 1);
            }
            let selected;
            if (activeSeason.disciplineId === WCupRankingCategorySeason.discipline.outdoorCode) {
                selected = next.findIndex(season => season.year === activeSeason.year);
            }
            else {
                selected = next.findIndex(season => activeSeason.year - 1 === season.year);
            }
            if (this.router.snapshot.queryParams['demo']) {
                comboSeason.push(next);
            }
            (this.filtersType[3].options).options_subject.next(next);
            if (this.router.snapshot.queryParams['year']) {
                selected = next.findIndex(season => season.year.toString() === this.router.snapshot.queryParams['year']);
            }
            // Check the year is not present.
            (this.filtersType[3].options).options_selected_subject.next(next[selected] ? next[selected] : next[0]);
        });
        (this.filtersType[3].options).options_selected_subject
            .asObservable()
            .pipe(filter(year => year !== undefined), mergeMap(year => {
            const WCupRankingCategoryLocator = new WCupRankingCategoryListLocator();
            WCupRankingCategoryLocator.discipline.id =
                WCupRankingCategoryLocator.discipline.outdoorCode;
            WCupRankingCategoryLocator.year.value = year.year;
            const rankingCategoryLocator = this.views.get(WCupRankingCategoryLocator);
            return rankingCategoryLocator.getDataStream().pipe(combineLatest((this.filtersType[1].options).options_selected_subject.asObservable()), map(([a, type]) => a.filter(a => type.name === 'Individual'
                ? a.isTeam === false
                : a.isTeam === true)));
        }))
            .subscribe(next => {
            next.forEach(value => {
                value.name = value.name
                    ? value.name
                    : this.helper.getCategoryInfoByCode(value.code).name;
            });
            (this.filtersType[2].options).options_subject.next(next);
            /*(<IFilterComboComponent>(
              this.filtersType[2].options
            )).options_selected_subject.next(next[0]);*/
        });
    }
}
FilterWCupRankingService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FilterWCupRankingService_Factory() { return new FilterWCupRankingService(i0.ɵɵinject(i1.WaHelperService), i0.ɵɵinject(i2.ViewDataService), i0.ɵɵinject(i3.ActivatedRoute), i0.ɵɵinject(i4.HttpClient)); }, token: FilterWCupRankingService, providedIn: "root" });
